import React from "react";

import ContextStepView from "./ContextStepView";
import useContextStep from "./useContextStep";

const ContextStep = ({ onNext, onBack, userRole }) => {
  const context = useContextStep();

  const handleCloseSnackbar = (_, reason) => {
    if (reason === "clickaway") return;
    context.setOpenSnackbar(false);
  };

  return (
    <ContextStepView
      {...context}
      handleCloseSnackbar={handleCloseSnackbar}
      onBack={onBack}
      onNext={onNext}
      userRole={userRole}
    />
  );
};

export default ContextStep;
